import { createSlice } from "@reduxjs/toolkit";
import { IXSifterUser } from "../types/XSifterAppUser";
// import { useNavigate } from "react-router-dom";

export interface IXSifterAppState {
    displayMessage: string | undefined;
    displayMessageTyoe:  ("success" | "info" | "warning" | "error") | undefined;
    currentUser: IXSifterUser | undefined;
    hasQueryTitle: boolean;
    currentQueryId: string | null;
}

const initialAppReducerState: IXSifterAppState = {
    displayMessage: undefined,
    displayMessageTyoe: undefined,
    currentUser: undefined,
    hasQueryTitle: false,
    currentQueryId: null,
};

export const appSlice = createSlice({
    name: 'app',
    initialState: initialAppReducerState,
    reducers: {
        setDisplayMessage(state, action) {
            state.displayMessage = action.payload;
            state.displayMessageTyoe = undefined;
        },
        setDisplayMessageType(state, action) {
            state.displayMessageTyoe = action.payload;
        },
        clearDisplayMessage(state) {
            state.displayMessage = undefined;
            state.displayMessageTyoe = undefined;
        },
        setCurrentUser(state, action) {
            state.currentUser = action.payload;
        },
        setHasQueryTitle(state, action) {
            state.hasQueryTitle = action.payload;
        },
        setCurrentQueryId(state, action) {
            state.currentQueryId = action.payload;
        }
    },
});

export const { 
    setDisplayMessage, 
    setDisplayMessageType, 
    clearDisplayMessage, 
    setCurrentUser, 
    setHasQueryTitle, 
    setCurrentQueryId 
} = appSlice.actions;

export default appSlice.reducer;
